import React, { useState } from 'react';
import { Button } from '../components/UI/Button';
import { LifetimePartnerForm } from '../components/Payment/LifetimePartnerForm';
import { PaystackScript } from '../components/Payment/PaystackScript';
import { Check, ArrowRight, Award } from 'lucide-react';
import { Link } from 'react-router-dom';
export const LifetimePartner = () => {
  const [paymentStatus, setPaymentStatus] = useState<'pending' | 'success' | 'form'>('pending');
  const [reference, setReference] = useState('');
  const [showPaymentForm, setShowPaymentForm] = useState(false);
  const handleSuccess = (reference: string) => {
    setReference(reference);
    setPaymentStatus('form');
    window.scrollTo(0, 0);
  };
  const handleFormSubmit = e => {
    e.preventDefault();
    const formData = new FormData(e.target);
    fetch('https://formspree.io/f/mldpapna', {
      method: 'POST',
      body: formData,
      headers: {
        Accept: 'application/json'
      }
    }).then(response => {
      if (response.ok) {
        setPaymentStatus('success');
        // Redirect to WhatsApp group
        window.location.href = 'https://chat.whatsapp.com/BslF3e6Z9hk4ar8agDfQ51';
      } else {
        throw new Error('Form submission failed');
      }
    }).catch(error => {
      console.error('Error:', error);
      // Handle error state
    });
  };
  if (paymentStatus === 'success') {
    return <div className="pt-20 bg-white min-h-screen" data-id="element-3662">
        <div className="container mx-auto px-4 py-16" data-id="element-3663">
          <div className="max-w-3xl mx-auto text-center" data-id="element-3664">
            <div className="inline-block w-20 h-20 bg-gray-100 rounded-full flex items-center justify-center mb-6" data-id="element-3665">
              <Check size={40} className="text-gray-700" data-id="element-3666" />
            </div>
            <h1 className="text-3xl md:text-4xl font-bold text-gray-800 mb-6" data-id="element-3667">
              Welcome to The Networking Salon Lifetime Partner Access!
            </h1>
            <p className="text-xl text-gray-600 mb-8" data-id="element-3668">
              Thank you for joining our community. Your registration was
              successful.
            </p>
            <p className="text-gray-600 mb-12" data-id="element-3669">
              We're redirecting you to our WhatsApp community...
            </p>
          </div>
        </div>
      </div>;
  }
  if (paymentStatus === 'form') {
    return <div className="pt-20 bg-white min-h-screen" data-id="element-3670">
        <div className="container mx-auto px-4 py-16" data-id="element-3671">
          <div className="max-w-3xl mx-auto text-center mb-8" data-id="element-3672">
            <div className="inline-block w-20 h-20 bg-gray-100 rounded-full flex items-center justify-center mb-6" data-id="element-3673">
              <Check size={40} className="text-gray-700" data-id="element-3674" />
            </div>
            <h1 className="text-3xl md:text-4xl font-bold text-gray-800 mb-6" data-id="element-3675">
              Payment Successful!
            </h1>
            <p className="text-xl text-gray-600 mb-8" data-id="element-3676">
              Please complete your registration to join The Networking Salon as
              a Lifetime Partner.
            </p>
            <p className="text-gray-600 mb-8" data-id="element-3677">
              Reference ID: <span className="font-medium" data-id="element-3678">{reference}</span>
            </p>
          </div>
          <div className="max-w-2xl mx-auto border-2 border-gray-300 rounded-lg p-8" data-id="element-3679">
            <h2 className="text-2xl font-bold text-gray-800 mb-6 text-center" data-id="element-3680">
              Complete Your Registration
            </h2>
            <form onSubmit={handleFormSubmit} className="space-y-6" data-id="element-3681">
              <input type="hidden" name="payment_reference" value={reference} data-id="element-3682" />
              <div data-id="element-3683">
                <label className="block text-gray-700 font-medium mb-1" data-id="element-3684">
                  Full Name <span className="text-gray-500" data-id="element-3685">(required)</span>
                </label>
                <input type="text" name="name" required className="w-full px-4 py-2 border-2 border-gray-300 rounded-md" data-id="element-3686" />
              </div>
              <div data-id="element-3687">
                <label className="block text-gray-700 font-medium mb-1" data-id="element-3688">
                  Email <span className="text-gray-500" data-id="element-3689">(required)</span>
                </label>
                <input type="email" name="email" required className="w-full px-4 py-2 border-2 border-gray-300 rounded-md" data-id="element-3690" />
              </div>
              <div data-id="element-3691">
                <label className="block text-gray-700 font-medium mb-1" data-id="element-3692">
                  Phone Number <span className="text-gray-500" data-id="element-3693">(required)</span>
                </label>
                <input type="tel" name="phone" required className="w-full px-4 py-2 border-2 border-gray-300 rounded-md" data-id="element-3694" />
              </div>
              <div data-id="element-3695">
                <label className="block text-gray-700 font-medium mb-1" data-id="element-3696">
                  Business/Organization{' '}
                  <span className="text-gray-500" data-id="element-3697">(if applicable)</span>
                </label>
                <input type="text" name="business" className="w-full px-4 py-2 border-2 border-gray-300 rounded-md" data-id="element-3698" />
              </div>
              <div data-id="element-3699">
                <label className="block text-gray-700 font-medium mb-1" data-id="element-3700">
                  What are your main goals for joining as a Lifetime Partner?{' '}
                  <span className="text-gray-500" data-id="element-3701">(required)</span>
                </label>
                <textarea name="goals" required rows={4} className="w-full px-4 py-2 border-2 border-gray-300 rounded-md" data-id="element-3702" />
              </div>
              <div data-id="element-3703">
                <Button type="submit" className="w-full" data-id="element-3704">
                  Complete Registration
                </Button>
              </div>
            </form>
          </div>
        </div>
      </div>;
  }
  return <div className="pt-20 bg-white" data-id="element-3705">
      <PaystackScript data-id="element-3706" />
      {/* Hero Section */}
      <section className="relative py-20 border-b border-gray-200" data-id="element-3707">
        <div className="absolute inset-0 z-0" data-id="element-3708">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/bNxF5qHdCS6UJLX4hcirCA/IMG_7209.jpg" alt="The Networking Salon" className="w-full h-full object-cover grayscale" data-id="element-3709" />
          <div className="absolute inset-0 bg-black bg-opacity-60" data-id="element-3710"></div>
        </div>
        <div className="container mx-auto px-4 relative z-10" data-id="element-3711">
          <div className="max-w-3xl mx-auto text-center" data-id="element-3712">
            <div className="inline-block bg-white text-gray-800 px-4 py-1 rounded-full text-sm font-bold mb-6" data-id="element-3713">
              LIFETIME PARTNER ACCESS
            </div>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6" data-id="element-3714">
              Join the Circle of Builders
            </h1>
            <p className="text-xl text-gray-200 mb-8" data-id="element-3715">
              Strategic partnerships for founders, leaders, and visionaries who
              see relationships as strategy and community as an accelerator for
              growth.
            </p>
            <Button className="text-lg px-8 py-4" onClick={() => {
            setShowPaymentForm(true);
            setTimeout(() => {
              const element = document.getElementById('payment-form');
              if (element) {
                element.scrollIntoView({
                  behavior: 'smooth'
                });
              }
            }, 100);
          }} data-id="element-3716">
              Get Lifetime Partner Access (₦50,000)
            </Button>
          </div>
        </div>
      </section>
      {/* Main Content */}
      <section className="py-16" data-id="element-3717">
        <div className="container mx-auto px-4" data-id="element-3718">
          <div className="max-w-3xl mx-auto" data-id="element-3719">
            <div className="border-2 border-gray-300 rounded-lg p-8 mb-12" data-id="element-3720">
              <h2 className="text-2xl font-bold text-gray-800 mb-6 text-center" data-id="element-3721">
                🌟 The Networking Salon — Lifetime Partner Access
              </h2>
              <p className="text-gray-700 mb-6" data-id="element-3722">
                Welcome to the Circle of Builders.
              </p>
              <p className="text-gray-700 mb-6" data-id="element-3723">
                Lifetime Partner Access is designed for those who don't just
                want to network — they want to build. It's for founders,
                leaders, and visionaries who see relationships as strategy and
                community as an accelerator for growth.
              </p>
              <p className="text-gray-700 mb-8" data-id="element-3724">
                This tier is for the few who want a deeper seat at the table —
                where ideas become action, projects get personalized support,
                and your brand becomes part of the story we're building
                together.
              </p>
              <h3 className="text-xl font-bold text-gray-800 mb-4" data-id="element-3725">
                💼 What Lifetime Partner Access Offers
              </h3>
              <div className="space-y-4 mb-8" data-id="element-3726">
                <div className="flex items-start" data-id="element-3727">
                  <span className="mr-2" data-id="element-3728">🎯</span>
                  <div data-id="element-3729">
                    <p className="font-bold text-gray-800" data-id="element-3730">
                      One-on-One Strategic Guidance
                    </p>
                    <p className="text-gray-700" data-id="element-3731">
                      Personalized sessions to refine your goals, business
                      models, or growth strategy — with hands-on guidance
                      tailored to your unique journey.
                    </p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-3732">
                  <span className="mr-2" data-id="element-3733">💡</span>
                  <div data-id="element-3734">
                    <p className="font-bold text-gray-800" data-id="element-3735">
                      Project & Business Handholding
                    </p>
                    <p className="text-gray-700" data-id="element-3736">
                      Get ongoing support on your individual or organizational
                      projects. We help you move from ideas to execution with
                      structure, accountability, and access to tools that work.
                    </p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-3737">
                  <span className="mr-2" data-id="element-3738">🧠</span>
                  <div data-id="element-3739">
                    <p className="font-bold text-gray-800" data-id="element-3740">
                      Access to Advanced Masterminds
                    </p>
                    <p className="text-gray-700" data-id="element-3741">
                      Join curated mastermind circles that bring together
                      high-performing entrepreneurs, creators, and executives
                      focused on intentional growth and collective intelligence.
                    </p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-3742">
                  <span className="mr-2" data-id="element-3743">🌍</span>
                  <div data-id="element-3744">
                    <p className="font-bold text-gray-800" data-id="element-3745">
                      Brand Visibility & Features
                    </p>
                    <p className="text-gray-700" data-id="element-3746">
                      Showcase your brand, initiative, or business across The
                      Networking Salon website and platforms. Your work deserves
                      to be seen — by the right people.
                    </p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-3747">
                  <span className="mr-2" data-id="element-3748">🎟️</span>
                  <div data-id="element-3749">
                    <p className="font-bold text-gray-800" data-id="element-3750">
                      Exclusive Event Benefits
                    </p>
                    <p className="text-gray-700" data-id="element-3751">
                      Enjoy lifetime discounts on all in-person events and
                      experiences hosted by The Networking Salon — from private
                      dinners to public summits.
                    </p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-3752">
                  <span className="mr-2" data-id="element-3753">🗂️</span>
                  <div data-id="element-3754">
                    <p className="font-bold text-gray-800" data-id="element-3755">
                      Resource Catalogue Access
                    </p>
                    <p className="text-gray-700" data-id="element-3756">
                      Gain full access to our growing library of templates,
                      strategy tools, and playbooks that simplify
                      decision-making and amplify your impact.
                    </p>
                  </div>
                </div>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-4" data-id="element-3757">
                💎 Your Investment
              </h3>
              <div className="bg-gray-100 p-6 rounded-lg mb-8 text-center" data-id="element-3758">
                <p className="text-2xl font-bold text-gray-800 mb-2" data-id="element-3759">
                  ₦100,000 — Lifetime Access
                </p>
                <p className="text-gray-700 italic" data-id="element-3760">
                  (Currently discounted to ₦50,000)
                </p>
                <p className="text-gray-700 mt-4" data-id="element-3761">
                  This is a one-time investment for those ready to grow
                  intentionally, connect deeply, and align with a network built
                  for impact.
                </p>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-4" data-id="element-3762">
                🌿 Why Become a Lifetime Partner
              </h3>
              <p className="text-gray-700 mb-4" data-id="element-3763">
                Becoming a Lifetime Partner means joining a circle of committed
                individuals shaping what The Networking Salon stands for —
                collaboration, generosity, and transformation.
              </p>
              <p className="text-gray-700 mb-4" data-id="element-3764">
                You're not just gaining access — you're becoming a foundational
                voice in a movement that bridges people, purpose, and
                possibility.
              </p>
              <p className="text-gray-700 font-medium" data-id="element-3765">
                This is more than membership. It's partnership — for life. Your
                seat at the table is ready.
              </p>
            </div>
            {showPaymentForm && <div id="payment-form" className="border-2 border-gray-300 rounded-lg p-8" data-id="element-3766">
                <LifetimePartnerForm onSuccess={handleSuccess} data-id="element-3767" />
              </div>}
          </div>
        </div>
      </section>
    </div>;
};